import {axiosInstance} from '../../api/api';

export const generateSerialNumber = (
  successCallback,
  errorCallback,
  sequenceNumber,
) => {
  return () => {
    axiosInstance
      .post(`/station/serial-number/${sequenceNumber}`)
      .then(({data}) => {
        successCallback(data);
      })
      .catch(err => {
        errorCallback(err);
      });
  };
};
